import { createSlice } from '@reduxjs/toolkit';

const initialStatePSubscriptions = {
    listLoading: false,
    actionsLoading: false,
    pSubscriptions: undefined,
    pSubscriptionsDetails: undefined,
    success: null,
    error: null,
};
export const callTypes = {
    list: "list",
    action: "action"
};

export const pSubscriptionsSlice = createSlice({
    name: "pSubscriptions",
    initialState: initialStatePSubscriptions,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        catchSuccess: (state, action) => {
            state.error = null;
            state.success = action.payload.success;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        startCall: (state, action) => {
            state.error = null;
            state.success = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            };
        },
        // get List PPendings
        pSubscriptionsFetched: (state, action) => {
            state.listLoading = false;
            state.pSubscriptions = action.payload.pSubscriptions;
            state.error = null;
        },
        // get pPendings detail
        pSubscriptionsDetailsFetched: (state, action) => {
            state.listLoading = false;
            state.pSubscriptionsDetails = action.payload.pSubscriptionsDetails;
            state.error = null;
        },
        clear: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.pSubscriptionsDetails = undefined;
            state.error = null;
            state.success = null;
        },
        clearAll: (state, action) => {
            state.listLoading = false;
            state.actionsLoading = false;
            state.pSubscriptions = undefined;
            state.pSubscriptionsDetails = undefined;
            state.error = null;
            state.success = null;
        }
    }
});